export interface CompanyBrand {
  primaryColor: string;
  shellBackgroundColor: string;
  logoUrl: string | null;
}

export const DEFAULT_COMPANY_BRAND: CompanyBrand = {
  primaryColor: '#49FFC1',
  shellBackgroundColor: '#13322B',
  logoUrl: null,
};

export const BRAND_STORAGE_KEY = 'student_brand';
export const COMPANY_SLUG_STORAGE_KEY = 'student_company_slug';

export const normalizeCompanyBrand = (input?: Partial<CompanyBrand> | null): CompanyBrand => ({
  primaryColor: input?.primaryColor?.trim() || DEFAULT_COMPANY_BRAND.primaryColor,
  shellBackgroundColor: input?.shellBackgroundColor?.trim() || DEFAULT_COMPANY_BRAND.shellBackgroundColor,
  logoUrl: input?.logoUrl?.trim() || null,
});
